<template>
  <v-row>
    <v-col cols="12" md="6">
      <v-sheet rounded class="px-6 py-6">
        <div class="body-1 font-weight-bold mb-2">
          Facebook business manager
        </div>
        <div class="text-h4 mb-2">{{ businessName }}</div>
        <v-btn
          small
          text
          rounded
          class="mx-n2"
          @click="onChangeBusinessManagerClick"
        >
          <v-icon left>mdi-pencil-outline</v-icon>
          Změnit
        </v-btn>
      </v-sheet>
    </v-col>
    <v-col cols="12" md="6">
      <v-sheet rounded class="px-6 py-6">
        <div class="body-1 font-weight-bold mb-2">Reklamní účet</div>
        <div class="text-h4 mb-2">{{ adAccountName }}</div>
        <v-btn small text rounded class="mx-n2" @click="onChangeAdAccountClick">
          <v-icon left>mdi-pencil-outline</v-icon>
          Změnit
        </v-btn>
      </v-sheet>
    </v-col>
    <!--    <v-col cols="12">-->
    <!--      <v-sheet rounded class="px-6 py-6">-->
    <!--        <div class="body-1 font-weight-bold mb-2">Reklamní účet</div>-->
    <!--        <v-btn small text rounded class="mx-n2">-->
    <!--          <v-icon left>mdi-import</v-icon>-->
    <!--          Umístit na web-->
    <!--        </v-btn>-->
    <!--      </v-sheet>-->
    <!--    </v-col>-->
  </v-row>
</template>

<script>
import { get } from "vuex-pathify"

export default {
  name: "Facebook",
  computed: {
    ...get("accounts", [
      "adAccountId",
      "businessId",
      "findAdAccount",
      "findBusiness",
    ]),
    adAccountName() {
      const adAccount = this.findAdAccount(this.adAccountId)

      return adAccount ? adAccount.name : "Není nastaven"
    },
    businessName() {
      const business = this.findBusiness(this.businessId)

      return business ? business.name : "Není nastaven"
    },
  },
  methods: {
    onChangeBusinessManagerClick() {
      this.clearData()
      this.$router.push("/onboard/connect/business-manager")
    },
    onChangeAdAccountClick() {
      this.clearData()
      this.$router.push("/onboard/connect/ad-account")
    },
    clearData() {
      this.$store.dispatch("ads/clearModule")
      this.$store.dispatch("audiences/clearModule")
    },
  },
}
</script>
